import { render, staticRenderFns } from "./content_mainV2.vue?vue&type=template&id=1ec0e982&scoped=true&"
import script from "./content_mainV2.vue?vue&type=script&lang=js&"
export * from "./content_mainV2.vue?vue&type=script&lang=js&"
import style0 from "./content_mainV2.vue?vue&type=style&index=0&id=1ec0e982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0e982",
  null
  
)

export default component.exports